module.exports = __webpack_public_path__ + "img/img-4bcb2a.jpg";